import { combineReducers } from 'redux';

import * as actionTypes from '@store/salesContract/action-types';

const getSalesContractDetails = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_SALES_CONTRACT_DETAILS_FAILURE:
			return state;
		case actionTypes.FETCH_SALES_CONTRACT_DETAILS_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const salesContractReducer = combineReducers({
	salesContractDetails: getSalesContractDetails
});

export default salesContractReducer;
